import React from 'react';

const UserListTitle = ({ title }) => {
  return <div className="user-list-title">{title}</div>;
};

export default UserListTitle;
